import SelectEmailTemplateSection from './SelectEmailTemplateSection';

export default SelectEmailTemplateSection;
